
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contentful-preview/author/[slug]",
      function () {
        return require("private-next-pages/contentful-preview/author/[slug].page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contentful-preview/author/[slug]"])
      });
    }
  